import { useQuery, UseQueryOptions } from 'react-query';
import client from 'client';

const fetchRegistrations = async (eventId?: number, ticketId?: number, personId?: number) => {
    if (!eventId || !ticketId || !personId) {
        return [];
    }

    const response = await client().get<number[]>(
        `/api/v2/agenda/events/${eventId}/sessions/registered?ticketId=${ticketId}&personId=${personId}`
    );
    return response.data;
};

const useRegistrations = <TData = number[]>(
    eventId: number,
    ticketId: number,
    personId: number,
    options?: UseQueryOptions<number[], Error, TData>
) => {
    return useQuery(
        'registrations',
        () => fetchRegistrations(eventId, ticketId, personId),
        options
    );
};

export default useRegistrations;
